import { FC } from "react";

import { type StatusIconProps, initializeStatusIconProps } from "mds/utils/images";

export const PageListStatusIcon: FC<StatusIconProps> = (props) => {
  const { statusClassName, ...svgProps } = initializeStatusIconProps(props);
  return (
    <svg {...svgProps}>
      <path
        d="M6.79079 15H1.63623V3.54547H11.818V5.97578"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M3.54541 1H14.3636V6.69798"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M4.18164 6.72729H9.27255"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
      <path
        d="M4.18164 9.27271H6.61741"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
      <path
        d="M4.18164 11.8182H5.92407"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
      <rect className={statusClassName} height="6" rx="3" stroke="none" width="6" x="9" y="9" />
    </svg>
  );
};
